import { useTranslation } from "react-i18next";

const ChargebackStatusOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "PENDING",
      title: t("options.chargebackStatus.pending"),
      value: "PENDING",
      tag: ["non-closed"],
    },
    {
      key: "ACCEPTED",
      title: t("options.chargebackStatus.accepted"),
      value: "ACCEPTED",
      tag: ["non-closed"],
    },
    {
      key: "REJECTED",
      title: t("options.chargebackStatus.rejected"),
      value: "REJECTED",
      tag: ["non-closed"],
    },
    {
      key: "WITHDRAWN",
      title: t("options.chargebackStatus.withdrawn"),
      value: "WITHDRAWN",
      tag: ["non-closed"],
    },
    {
      key: "PENDING_CLOSED",
      title: t("options.chargebackStatus.pendingClosed"),
      value: "PENDING (CLOSED)",
      tag: ["closed"],
    },
    {
      key: "ACCEPTED_CLOSED",
      title: t("options.chargebackStatus.acceptedClosed"),
      value: "ACCEPTED (CLOSED)",
      tag: ["closed"],
    },
    {
      key: "REJECTED_CLOSED",
      title: t("options.chargebackStatus.rejectedClosed"),
      value: "REJECTED (CLOSED)",
      tag: ["closed"],
    },
    {
      key: "WITHDRAWN_CLOSED",
      title: t("options.chargebackStatus.withdrawnClosed"),
      value: "WITHDRAWN (CLOSED)",
      tag: ["closed"],
    },
  ];

  if (typeof list === "string") {
    if (list.toLowerCase() === "all") return options;
    return options.filter((option) =>
      option.tag?.some((tag) => tag === list.toLowerCase()),
    );
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default ChargebackStatusOptions;
